function initialState () {
	return {editingStep: {}};
}

export default {
	state: initialState,
	getters: {
		editingStep: state => state.editingStep
	},

	mutations: {
		editingStep(state, stepObj) {
			state.editingStep = JSON.parse(JSON.stringify(stepObj));
		},

		updateStepTitle(state, title) {
			state.editingStep.title = title;
		},

		updateStepDescription(state, description) {
			state.editingStep.description = description;
		},
		
		addChannelItem(state, payload) {
			let channelIndex = payload.channelIndex;
			let channelObj = payload.channelObj;
			state.editingStep.channels[channelIndex].items.push(channelObj);
		},

		reorderChannelItems(state, payload) {
			let channelIndex = payload.channelIndex;
			let fromIndex = payload.fromIndex;
			let toIndex = payload.toIndex;
			let element = state.editingStep.channels[channelIndex].items[fromIndex];
			////////////////////////////////////////////////////
			if (toIndex < fromIndex) {
				console.log('move item before');
				state.editingStep.channels[channelIndex].items.splice(fromIndex, 1);
				state.editingStep.channels[channelIndex].items.splice(toIndex, 0, element);
			} else if (toIndex == fromIndex || toIndex == fromIndex+1) {
				console.log('no need to move item');
			} else {
				console.log('move item after');
				state.editingStep.channels[channelIndex].items.splice(fromIndex, 1);
				state.editingStep.channels[channelIndex].items.splice(toIndex, 0, element);
			}
		},

		deleteChannelItem(state, payload) {
			let channelIndex = payload.channelIndex;
			let itemIndex = payload.itemIndex;
			state.editingStep.channels[channelIndex].items.splice(itemIndex, 1);
		},

		resetEditingStep (state) {
			Object.assign(state, initialState());
		}
	},

	actions: {
		editStep({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('editingStep', payload.editingStep);
				resolve();
			});
		},

		updateStepTitle({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('updateStepTitle', payload.title);
				resolve();
			});
		},

		updateStepDescription({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('updateStepDescription', payload.description);
				resolve();
			});
		},

		addChannelItem({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('addChannelItem', payload);
				resolve();
			});
		},

		reorderChannelItems({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('reorderChannelItems', payload);
				resolve();
			});
		},

		deleteChannelItem({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('deleteChannelItem', payload);
				resolve();
			});
		},

		resetEditingStep ({commit}) {
			return new Promise((resolve, reject) => {
				commit('resetEditingStep');
				resolve();
			});
		}
	}
}